import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-6xl" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-red-600 mb-4"
}
const _hoisted_3 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-500 mt-1"
}
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_6 = { class: "flex items-center gap-2 text-sm text-gray-400" }

import { computed, onMounted, ref } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import { useAgentGoLive } from '@/composables/useAgentGoLive'
import api from '@/store/api'
import { mapType } from '@/store/mappers'
import { iconFor } from '@/view/ai/agentIcons'
import AgentImpactModal from '@/view/ai/AgentImpactModal.vue'
import AgentPerformanceCard from '@/view/ai/AgentPerformanceCard.vue'
import {
  activeSlotCount,
  dashboardSections,
  dashboardStores,
  metricsForSlot,
  sectionSlots
} from '@/view/ai/agentsDashboardData'
import AgentsSummaryTiles from '@/view/ai/AgentsSummaryTiles.vue'


export default {
  __name: 'AgentsDashboard',
  setup(__props) {

const loading = ref(true)
const error = ref('')
const aggregates = ref({
  sales_driven_cents: 0,
  sales_driven_prior_cents: 0,
  conversations_count: 0,
  active_agents_count: 0
})
const agents = ref([])

// mapType drops inactive stores, so only live stores get a section.
const stores = computed(() => dashboardStores(mapType('store')))
const sections = computed(() => dashboardSections(stores.value))
const allSlots = computed(() => sectionSlots(sections.value))
const activeCount = computed(() => activeSlotCount(allSlots.value, agents.value, new Date()))
const slotMetrics = slot => metricsForSlot(slot, agents.value, new Date())

const loadSummary = async () => {
  const res = await api.call('GET', 'ai_agents_summary')
  const json = res?.data ?? res
  aggregates.value = json.aggregates || aggregates.value
  agents.value = json.agents || []
}

const goLive = useAgentGoLive()
const requestGoLive = (slot, agentId) => goLive.request(agentId, slot.agentType)
const confirmGoLive = async () => {
  if (await goLive.confirm()) await loadSummary()
}

onMounted(async () => {
  try {
    await Promise.all([loadSummary(), api.call('GET', 'stores?included=none')])
  } catch (e) {
    error.value = e?.response?.data?.errors?.[0] || 'Failed to load agents.'
  } finally {
    loading.value = false
  }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(NeueLoading, { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (agents.value.length)
          ? (_openBlock(), _createBlock(AgentsSummaryTiles, {
              key: 1,
              aggregates: aggregates.value,
              "active-count": activeCount.value,
              "slot-count": allSlots.value.length,
              class: "mb-10"
            }, null, 8, ["aggregates", "active-count", "slot-count"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
          return (_openBlock(), _createElementBlock("section", {
            key: section.key,
            class: "mb-10"
          }, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(section.title), 1),
            (section.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(section.description), 1))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "border-gray-200 my-4" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.slots, (slot) => {
                return (_openBlock(), _createBlock(AgentPerformanceCard, {
                  key: slot.key,
                  card: slot,
                  metrics: slotMetrics(slot),
                  onGoLive: $event => (requestGoLive(slot, $event))
                }, null, 8, ["card", "metrics", "onGoLive"]))
              }), 128))
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(iconFor)('clock')), { class: "h-4 w-4" })),
          _cache[1] || (_cache[1] = _createTextVNode(" More agents coming soon. ", -1))
        ])
      ]),
      _createVNode(AgentImpactModal, {
        "is-open": _unref(goLive).impactOpen.value,
        saving: _unref(goLive).saving.value,
        "agent-type": _unref(goLive).agentType.value,
        estimate: _unref(goLive).estimate.value,
        onConfirm: confirmGoLive,
        onCancel: _unref(goLive).cancel
      }, null, 8, ["is-open", "saving", "agent-type", "estimate", "onCancel"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}